import { useEffect, useMemo, useState } from "react";
import useMediaQuery from "../../../hooks/useMediaQuery";
import './Map.scss';

let panorama;

const makePanorama = async (
  position: any,
  map: any,
  oldPanorama: any,
  setPanoramaError: any
) => {
  if (!oldPanorama) {
    map.getStreetView().setVisible(false);
    setPanoramaError(false);
  } else {
    let svService = new google.maps.StreetViewService();
    let panoRequest = {
      location: new google.maps.LatLng(position),
      preference: google.maps.StreetViewPreference.NEAREST,
      source: google.maps.StreetViewSource.OUTDOOR,
    };

    svService.getPanorama(panoRequest, function (panoData, status) {
      setPanoramaError(false);
      if (status === google.maps.StreetViewStatus.OK) {
        panorama = new google.maps.StreetViewPanorama(
          document.getElementById("map") as any,
          {
            pano: panoData?.location?.pano,
            pov: {
              heading: 0,
              pitch: 0,
            },
          }
        );
      } else {
        panorama = new google.maps.StreetViewPanorama(
          document.getElementById("map") as any,
          {
            pano: panoData?.location?.pano,
            pov: {
              heading: 0,
              pitch: 0,
            },
          }
        );
        setPanoramaError(true);
      }
    });
  }
};

interface MapProps {
  centerPosition?: { lat: number; lng: number };
  markerPositionsGreen: any[];
  markerPositionsBlue: any[];
  radius?: number;
  panorama?: boolean;
  setPanorama: (value: boolean) => void;
  avarege?: number;
  median?: number;
  samples?: number;
  specialData: any[];
  tableType: string;
}

const CustomMap: React.FC<MapProps> = ({
  centerPosition = { lat: 42.357716, lng: -71.052816 },
  markerPositionsGreen,
  markerPositionsBlue,
  radius = 1,
  panorama = false,
  setPanorama,
  avarege,
  median,
  samples,
  specialData,
  tableType,
}) => {
  const [panoramaError, setPanoramaError] = useState(false);
  const [mapType, setMapType] = useState<"special" | "other">("other");

  const sortedNewSpecialData = useMemo(() => {
    return specialData.filter(
      (item: any) => item.process_state === "NEW SPECIAL"
    );
  }, [specialData]);

  const groupedProperties = markerPositionsBlue.reduce(
    (acc: any, property: any) => {
      const { address } = property;
      if (!acc[address]) {
        acc[address] = [];
      }
      acc[address].push(property);
      return acc;
    },
    {}
  );

  useEffect(() => {
    tableType === "special" ? setMapType("special") : setMapType("other");
  }, [tableType]);

  let currentInfoWindow: google.maps.InfoWindow | null = null;
  useEffect(() => {
    let map: any;
    async function initMap(): Promise<void> {
      //@ts-ignore
      const { Map } = (await google.maps.importLibrary(
        "maps"
      )) as google.maps.MapsLibrary;
      const { AdvancedMarkerElement } = (await google.maps.importLibrary(
        "marker"
      )) as google.maps.MarkerLibrary;
      const { LatLngBounds } = (await google.maps.importLibrary(
        "core"
      )) as google.maps.CoreLibrary;

      map = new Map(document.getElementById("map") as HTMLElement, {
        zoom: 15,
        center: centerPosition,
        mapId: "DEMO_MAP_ID",
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_TOP,
        },
        styles: [
          {
            featureType: "all",
            stylers: [{ visibility: "off" }],
          },
        ],
      });

      const parser = new DOMParser();

      // A marker with a custom inline SVG.
      const pinSvgString =
        '<svg xmlns="http://www.w3.org/2000/svg" width="39" height="45" viewBox="0 0 29 34" fill="none"><g filter="url(#filter0_d_11916_30909)"><path d="M12.9984 30C12.9984 30 3.89844 18.131 3.89844 13.1C3.89844 11.905 4.13382 10.7216 4.59113 9.61758C5.04845 8.51352 5.71875 7.51034 6.56377 6.66533C7.40878 5.82031 8.41196 5.15001 9.51602 4.6927C10.6201 4.23538 11.8034 4 12.9984 4C14.1935 4 15.3768 4.23538 16.4809 4.6927C17.5849 5.15001 18.5881 5.82031 19.4331 6.66533C20.2781 7.51034 20.9484 8.51352 21.4057 9.61758C21.8631 10.7216 22.0984 11.905 22.0984 13.1C22.0984 18.131 12.9984 30 12.9984 30Z" fill="#74B566"/><path d="M12.9984 29.1681C12.7517 28.8364 12.4019 28.3606 11.9831 27.7757C11.1336 26.5895 10.0019 24.9569 8.87098 23.1693C7.73901 21.38 6.61368 19.4444 5.77305 17.6509C4.92361 15.8385 4.39844 14.2395 4.39844 13.1C4.39844 11.9706 4.62088 10.8523 5.05307 9.80892C5.48526 8.76552 6.11874 7.81747 6.91732 7.01888C7.7159 6.2203 8.66396 5.58683 9.70736 5.15464C10.7508 4.72245 11.8691 4.5 12.9984 4.5C14.1278 4.5 15.2461 4.72245 16.2895 5.15464C17.3329 5.58683 18.281 6.2203 19.0796 7.01888C19.8781 7.81747 20.5116 8.76552 20.9438 9.80892C21.376 10.8523 21.5984 11.9706 21.5984 13.1C21.5984 14.2395 21.0733 15.8385 20.2238 17.6509C19.3832 19.4444 18.2579 21.38 17.1259 23.1693C15.995 24.9569 14.8633 26.5895 14.0138 27.7757C13.595 28.3606 13.2452 28.8364 12.9984 29.1681Z" stroke="#609854"/></g><path d="M11.8 18V14.4706H14.2V18H17.2V13.2941H19L13 8L7 13.2941H8.8V18H11.8Z" fill="white"/><defs><filter id="filter0_d_11916_30909" x="1.89844" y="0" width="26.1992" height="34" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dx="2"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11916_30909"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11916_30909" result="shape"/></filter></defs></svg>';
      const blueIcon =
        '<svg xmlns="http://www.w3.org/2000/svg" width="39" height="45" viewBox="0 0 29 34" fill="none"><g filter="url(#filter0_d_11908_11406)"><path d="M12.9984 30C12.9984 30 3.89844 18.131 3.89844 13.1C3.89844 11.905 4.13382 10.7216 4.59113 9.61758C5.04845 8.51352 5.71875 7.51034 6.56377 6.66533C7.40878 5.82031 8.41196 5.15001 9.51602 4.6927C10.6201 4.23538 11.8034 4 12.9984 4C14.1935 4 15.3768 4.23538 16.4809 4.6927C17.5849 5.15001 18.5881 5.82031 19.4331 6.66533C20.2781 7.51034 20.9484 8.51352 21.4057 9.61758C21.8631 10.7216 22.0984 11.905 22.0984 13.1C22.0984 18.131 12.9984 30 12.9984 30Z" fill="#5796D2"/><path d="M12.9984 29.1681C12.7517 28.8364 12.4019 28.3606 11.9831 27.7757C11.1336 26.5895 10.0019 24.9569 8.87098 23.1693C7.73901 21.38 6.61368 19.4444 5.77305 17.6509C4.92361 15.8385 4.39844 14.2395 4.39844 13.1C4.39844 11.9706 4.62088 10.8523 5.05307 9.80892C5.48526 8.76552 6.11874 7.81747 6.91732 7.01888C7.7159 6.2203 8.66396 5.58683 9.70736 5.15464C10.7508 4.72245 11.8691 4.5 12.9984 4.5C14.1278 4.5 15.2461 4.72245 16.2895 5.15464C17.3329 5.58683 18.281 6.2203 19.0796 7.01888C19.8781 7.81747 20.5116 8.76552 20.9438 9.80892C21.376 10.8523 21.5984 11.9706 21.5984 13.1C21.5984 14.2395 21.0733 15.8385 20.2238 17.6509C19.3832 19.4444 18.2579 21.38 17.1259 23.1693C15.995 24.9569 14.8633 26.5895 14.0138 27.7757C13.595 28.3606 13.2452 28.8364 12.9984 29.1681Z" stroke="#196FAF"/></g><path d="M11.8 18V14.4706H14.2V18H17.2V13.2941H19L13 8L7 13.2941H8.8V18H11.8Z" fill="white"/><defs><filter id="filter0_d_11908_11406" x="1.89844" y="0" width="26.1992" height="34" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dx="2"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11908_11406"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11908_11406" result="shape"/></filter></defs></svg>';
      const orangeIcon =
        '<svg width="29" height="35" viewBox="0 0 29 34" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_13430_41172)"><path d="M12.9984 30C12.9984 30 3.89844 18.131 3.89844 13.1C3.89844 11.905 4.13382 10.7216 4.59113 9.61758C5.04845 8.51352 5.71875 7.51034 6.56377 6.66533C7.40878 5.82031 8.41196 5.15001 9.51602 4.6927C10.6201 4.23538 11.8034 4 12.9984 4C14.1935 4 15.3768 4.23538 16.4809 4.6927C17.5849 5.15001 18.5881 5.82031 19.4331 6.66533C20.2781 7.51034 20.9484 8.51352 21.4057 9.61758C21.8631 10.7216 22.0984 11.905 22.0984 13.1C22.0984 18.131 12.9984 30 12.9984 30Z" fill="#EF6F22"/><path d="M12.9984 29.1681C12.7517 28.8364 12.4019 28.3606 11.9831 27.7757C11.1336 26.5895 10.0019 24.9569 8.87098 23.1693C7.73901 21.38 6.61368 19.4444 5.77305 17.6509C4.92361 15.8385 4.39844 14.2395 4.39844 13.1C4.39844 11.9706 4.62088 10.8523 5.05307 9.80892C5.48526 8.76552 6.11874 7.81747 6.91732 7.01888C7.7159 6.2203 8.66396 5.58683 9.70736 5.15464C10.7508 4.72245 11.8691 4.5 12.9984 4.5C14.1278 4.5 15.2461 4.72245 16.2895 5.15464C17.3329 5.58683 18.281 6.2203 19.0796 7.01888C19.8781 7.81747 20.5116 8.76552 20.9438 9.80892C21.376 10.8523 21.5984 11.9706 21.5984 13.1C21.5984 14.2395 21.0733 15.8385 20.2238 17.6509C19.3832 19.4444 18.2579 21.38 17.1259 23.1693C15.995 24.9569 14.8633 26.5895 14.0138 27.7757C13.595 28.3606 13.2452 28.8364 12.9984 29.1681Z" stroke="#C24040"/></g><path d="M11.8 18V14.4706H14.2V18H17.2V13.2941H19L13 8L7 13.2941H8.8V18H11.8Z" fill="white"/><defs><filter id="filter0_d_13430_41172" x="1.89844" y="0" width="26.1992" height="34" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dx="2"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13430_41172"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13430_41172" result="shape"/></filter></defs></svg>';

      // The marker, positioned at Uluru
      markerPositionsGreen.map((item: any) => {
        const pinSvg = parser.parseFromString(
          pinSvgString,
          "image/svg+xml"
        ).documentElement;
        const marker = new AdvancedMarkerElement({
          map: map,
          position: item.position,
          title: "Click marker for data",
          content: pinSvg,
        });
        const infoWindowContent = `<div style="display: flex; row-gap: 5px; flex-direction: column; white-space: nowrap; text-align: left; font-family: Roboto; font-size: 14px; font-weight: 400; line-height: 16px;"><div style="display: flex; column-gap: 8px"><div>Address:</div><div>${
          item.address
        }</div></div><div style="display: flex; column-gap: 8px"><div>BR:</div><div>${
          item.bedrooms
        }</div></div><div style="display: flex; column-gap: 8px"><div>Ba:</div><div>${item.baths.replace(
          "ba",
          ""
        )}</div></div><div style="display: flex; column-gap: 8px"><div>Property type:</div><div>${
          item.property_type
        }</div></div><div style="display: flex; column-gap: 8px"><div>Price:</div><div>${
          item.price
        }</div></div></div>`;

        const infoWindow = new google.maps.InfoWindow({
          content: infoWindowContent,
          maxWidth: 400,
        });

        marker.addListener("click", () => {
          if (currentInfoWindow) {
            currentInfoWindow.close();
          }
          infoWindow.open(map, marker);
          currentInfoWindow = infoWindow;
        });
      });

      // The marker, positioned at Uluru
      groupedProperties &&
        Object.values(groupedProperties).map(async (item: any) => {
          const pinSvg2 = parser.parseFromString(
            blueIcon,
            "image/svg+xml"
          ).documentElement;
          const marker2 = await new AdvancedMarkerElement({
            map: map,
            position: item[0].position,
            title: "Click marker for data",
            content: pinSvg2,
          });

          const infoWindowContent = generateInfoWindowContent(item);

          const infoWindow = new google.maps.InfoWindow({
            content: infoWindowContent,
            maxWidth: 400,
          });
          marker2.addListener("click", () => {
            if (currentInfoWindow) {
              currentInfoWindow.close();
            }
            infoWindow.open(map, marker2);
            currentInfoWindow = infoWindow;
          });
        });

      if (mapType === "special") {
        sortedNewSpecialData.map(async (item: any) => {
          const pinSvg3 = parser.parseFromString(
            orangeIcon,
            "image/svg+xml"
          ).documentElement;
          const marker3 = await new AdvancedMarkerElement({
            map: map,
            position: { lat: item.latitude, lng: item.longitude },
            title: "Click marker for data",
            content: pinSvg3,
          });
          const infoWindowContent = `
          <div style="display: flex; flex-direction: column; gap: 5px; white-space: nowrap; text-align: left; font-family: Roboto; font-size: 14px; font-weight: 400; line-height: 16px;">
            <div style="display: flex; gap: 8px;">
              <div>Property Name:</div>
              <div>${item["Property Name"]}</div>
            </div>
            <div style="display: flex; gap: 8px;">
              <div>Address:</div>
              <div>${item["Formatted Address"]}</div>
            </div>
            <div style="display: flex; gap: 8px;">
              <div>Description:</div>
              <div>${item.process_state}</div>
            </div>
            <div style="display: flex; gap: 8px;">
              <div>Web address:</div>
              <a 
                style="color: #196faf; text-decoration: underline;" 
                href=${
                  item["Web Address"] === "x"
                    ? "javascript:void(0)"
                    : item["Web Address"]
                }
                target="_blank""
              >${item["Web Address"]}</a>
            </div>
            <div style="display: flex; gap: 8px;">
              <div>Contact us:</div>
              <a 
                style="color: #196faf; text-decoration: underline"
                href=${
                  item["Contact Us URL"] === "x"
                    ? "javascript:void(0)"
                    : item["Contact Us URL"]
                } 
                target="_blank""
              >
                ${item["Contact Us URL"]}
              </a>
            </div>
          </div>`;

          const infoWindow = new google.maps.InfoWindow({
            content: infoWindowContent,
            maxWidth: 300,
          });

          marker3.addListener("click", () => {
            if (currentInfoWindow) {
              currentInfoWindow.close();
            }

            infoWindow.open(map, marker3);
            currentInfoWindow = infoWindow;
          });
        });

        const cityCircle = new google.maps.Circle({
          strokeColor: "#C24040",
          strokeWeight: 2,
          fillOpacity: 0.01,
          map,
          center: centerPosition,
          radius: 3 * 1.60934 * 1000,
        });

        map.fitBounds(cityCircle.getBounds());
      } else {
        const cityCircle = new google.maps.Circle({
          strokeColor: "#C24040",
          strokeWeight: 2,
          fillOpacity: 0,
          map,
          center: centerPosition,
          radius: radius * 1.60934 * 1000,
        });

        map.fitBounds(cityCircle.getBounds());
      }

      makePanorama(panorama, map, panorama, setPanoramaError);
    }

    initMap();
  }, [
    JSON.stringify(panorama),
    markerPositionsGreen,
    markerPositionsBlue,
    sortedNewSpecialData,
    mapType,
  ]);

  const generateInfoWindowContent = (items: any[]) => {
    let content = `
        <div style="display: flex; row-gap: 5px; flex-direction: column; white-space: nowrap; text-align: left; font-family: Roboto; font-size: 14px; font-weight: 400; line-height: 16px; max-height: 300px; overflow-y: auto; overflow-x: auto;">`;

    items.forEach((item, index) => {
      content += `
        <div style="display: flex; column-gap: 8px"><div>Address:</div><div>${
          item.address
        }</div></div>
        <div style="display: flex; column-gap: 8px"><div>BR:</div><div>${
          item.bedrooms
        }</div></div>
        <div style="display: flex; column-gap: 8px"><div>Ba:</div><div>${item.baths.replace(
          "ba",
          ""
        )}</div></div>
        <div style="display: flex; column-gap: 8px"><div>Property type:</div><div>${
          item.property_type
        }</div></div>
        <div style="display: flex; column-gap: 8px"><div>Price:</div><div>${
          item.price
        }</div></div>`;

      if (items.length > 1 && index < items.length - 1) {
        content += `<hr style="border: 1px solid #D2DBE8;">`;
      }
    });

    content += `</div>`;
    return content;
  };

  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <>
      <div className="mapHeader">
        <h3 className="mapHeaderTitle">Map View of Rent Comps</h3>
      </div>

      <div>
        <div id="map" style={{ width: "100%", height: "400px" }}></div>
          {panorama !== false && (
            <button className="resultGoBack" onClick={() => setPanorama(false)}>
              {/* <GoBackSVG /> */}
              Back to map view
            </button>
          )}
          {panoramaError && (
            <div className="resultNoPanorama">
              Street View imagery is not available for this location
            </div>
          )}
      </div>
    </>
  );
};

export default CustomMap;
